import { createReducer } from '@reduxjs/toolkit'
import { clearModal, updateModal } from '../actions'

const initialState = {}

export const modal = createReducer(initialState, {
  [clearModal.type]: (state, action) => initialState,
  [updateModal.type]: (state, action) => action.payload
})
